<template>
    <div class="homework-list-page">
        <div class="xzy_dtms">
          练习历史
          <img class="gbdt_ms" src="../images/gbdt_ms.png" @click="historyListClose" alt="">
        </div>
        <div class="lxls_fs">
          <div class="lxls_jgcs">
            <div>及格次数</div>
            <div class="lxls_fsse">{{ exerciseData.passNum || 0 }}</div>
          </div>
          <div class="lxls_jgcs">
            <div>平均分数</div>
            <div class="lxls_fsse">{{ exerciseData.average || 0 }}</div>
          </div>
          <div class="lxls_jgcs">
            <div>最高分数</div>
            <div class="lxls_fsse">{{ exerciseData.maxScore || 0 }}</div>
          </div>
        </div>
        <div v-if="historyList.length" style="max-height: 500px;overflow-y: auto;">
            <div class="zyfs_cddw" v-for="item in historyList" :key="item.id">
                <div class="zyfs_jgbz" :class="item.is_pass != 1 ? 'zyfs_jgbzbjg' : ''">{{ item.is_pass == 1 ? '及格' : '不及格' }}</div>
                <div class="zyfs_whx">
                    <div class="zyfs_bas">
                        <div>作业分数</div>
                        <div class="zyfs_zyfsbsf">{{ item.score }}<span class="zyfs_fsdf">分</span></div>
                    </div>
                    <div class="zyfs_yibai">
                        <div class="zyfs_ztsyb">
                            <div>总题数</div>
                            <div class="zyfs_ztsyib">{{ item.pass_num + item.fail_num + item.short_answer_num }}</div>
                        </div>
                        <div class="zyfs_ztsyb">
                            <div>答对题数</div>
                            <div style="color: #10B881;" class="zyfs_ztsyib">{{ item.pass_num }}</div>
                        </div>
                        <div class="zyfs_ztsyb">
                            <div>答错题数</div>
                            <div style="color: #FF8982;" class="zyfs_ztsyib">{{ item.fail_num }}</div>
                        </div>
                        <div class="zyfs_ztsyb">
                            <div>简答题</div>
                            <div class="zyfs_ztsyib">{{ item.short_answer_num }}</div>
                        </div>
                    </div>
                    <div class="zyfs_wcsj">
                        <div>完成时间</div>
                        <div style="font-size: 12px;margin-top: 10px;">{{ item.create_time }}</div>
                    </div>
                    <div class="zyfs_cktm" @click="Taozzye(item)">
                        <div class="zyfs_cktman">查看题目</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <el-empty :image-size="200"></el-empty>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'historyList',
        props: {
            dialogVisibleck: {
                type: Boolean,
                default: false
            },
            exerciseData: {
                type: Object,
                default: () => ({})
            },
            payload: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                historyList: [],
                pagination: {
                    page: 1,
                    pageNum: 5,
                    pageSize: 0
                }
            }
        },
        watch: {
            dialogVisibleck: {
                handler(val) {
                    console.log(val)
                    if (val) {
                        this.pagination.page = 1
                        this.historyList = []
                        this.$nextTick(() => {
                            this.fetch()
                        })
                    }
                },
                immediate: true
            }
        },
        methods: {
            async fetch() {
                const params = {
                    ucq_id: this.payload.ucqid,
                    page: this.pagination.page,
                    page_nums: this.pagination.pageNum
                }
                const res = await this.$axios.post('user/question/historyList', params)
                this.pagination.pageSize = (res.data.data.count > 10 ? Math.ceil(res.data.data.count/this.pagination.pageNum) : 1)
                
                if (this.pagination.page === 1) {
                    this.historyList = []
                }
                this.historyList = [...this.historyList, ...res.data.data.list]
            },
            historyListClose() {
                this.$emit('historyListClose')
            },
            Taozzye(item) {
                this.$emit('Taozzye', item)
            }
        }
    }
</script>

<style lang="scss" scoped>
.homework-list-page {
    .xzy_dtms {
        text-align: center;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-600;
        font-weight: 600;
        color: #202020;
        padding-top: 24px;
        .gbdt_ms {
            width: 24px;
            height: 24px;
            position: absolute;
            right: 24px;
            cursor: pointer;
        }
    }
    .lxls_fs {
        width: 672px;
        height: 62px;
        background: #f4f6f6;
        border-radius: 8px;
        display: flex;
        margin: 0 auto;
        margin-top: 24px;
        .lxls_jgcs {
            width: 224px;
            height: 63px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            text-align: center;
            color: #848586;
            margin-top: 8px;
            .lxls_fsse {
                font-size: 18px;
                font-family: PingFang SC, PingFang SC-600;
                font-weight: 600;
                color: #202020;
                margin-top: 2px;
            }
        }
    }
    .zyfs_cddw {
        width: 672px;
        height: 92px;
        background: #ffffff;
        border: 1px solid #e3e8e9;
        border-radius: 8px;
        margin: 0 auto;
        margin-top: 7.5px;
        .zyfs_jgbz {
            width: 40px;
            height: 25px;
            background: #10b881;
            border-radius: 8px 0px 8px 0px;
            position: relative;
            z-index: 1;
            text-align: center;
            line-height: 25px;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            color: #ffffff;
        }
        .zyfs_jgbzbjg {
            width: 52px;
            height: 25px;
            background: #ff8982;
            border-radius: 8px 0px 8px 0px;
            position: relative;
            z-index: 1;
            text-align: center;
            line-height: 25px;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            color: #ffffff;
        }
        .zyfs_whx {
            width: 648px;
            height: 76px;
            background: #f6f7f9;
            border-radius: 8px;
            margin: 0 auto;
            margin-top: -16px;
            display: flex;
            .zyfs_cktm {
                width: 104px;
                height: 48px;
                margin-top: 10.5px;
                .zyfs_cktman {
                    width: 80px;
                    height: 36px;
                    background: #eaf1ff;
                    border-radius: 100px;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-400;
                    font-weight: 400;
                    text-align: center;
                    color: #286bff;
                    line-height: 36px;
                    margin: 0 auto;
                    margin-top: 6px;
                    cursor: pointer;
                }
            }
            .zyfs_wcsj {
                width: 144px;
                height: 48px;
                border-right: 1px solid #dadce0;
                text-align: center;
                margin-top: 10.5px;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-400;
                font-weight: 400;
                color: #848586;
            }
            .zyfs_yibai {
                width: 304px;
                height: 48px;
                border-right: 1px solid #dadce0;
                text-align: center;
                margin-top: 10.5px;
                display: flex;
                .zyfs_ztsyb {
                    width: 80px;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-400;
                    font-weight: 400;
                    color: #848586;
                    .zyfs_ztsyib {
                        font-size: 18px;
                        font-family: PingFang SC, PingFang SC-600;
                        font-weight: 600;
                        color: #202020;
                        margin-top: 6.5px;
                    }
                }
            }
            .zyfs_bas {
                width: 96px;
                height: 48px;
                border-right: 1px solid #dadce0;
                text-align: center;
                margin-top: 10.5px;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-400;
                font-weight: 400;
                color: #848586;
                .zyfs_zyfsbsf {
                    font-size: 24px;
                    font-family: DINPro, DINPro-700;
                    font-weight: 700;
                    color: #286bff;
                    margin-top: 4px;
                    .zyfs_fsdf {
                        font-size: 12px;
                        font-family: PingFang SC, PingFang SC-400;
                        font-weight: 400;
                        color: #848586;
                        margin-left: 4px;
                    }
                }
            }
        }
    }

}
</style>